import React from 'react';
import { useRecordContext, useInput, Labeled, InputHelperText } from 'react-admin';
import ReactJson from 'react-json-view';
import { FormHelperText } from '@mui/material';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var JsonField = function (_a) {
    var source = _a.source, _b = _a.jsonString, jsonString = _b === void 0 ? false : _b, _c = _a.reactJsonOptions, reactJsonOptions = _c === void 0 ? {} : _c;
    var record = useRecordContext();
    var src = record[source];
    if (jsonString) {
        src = JSON.parse(src);
    }
    return React.createElement(ReactJson, __assign({}, reactJsonOptions, { src: src || {} }));
};

var JsonInput = function (props) {
    var _a = useInput(props), _b = _a.field, value = _b.value, onChange = _b.onChange, _c = _a.fieldState, isTouched = _c.isTouched, error = _c.error, isSubmitted = _a.formState.isSubmitted, isRequired = _a.isRequired;
    var source = props.source, label = props.label, helperText = props.helperText, _d = props.jsonString, jsonString = _d === void 0 ? false : _d, reactJsonOptions = props.reactJsonOptions;
    function change(updatedSrc) {
        var updatedValue = updatedSrc;
        if (jsonString) {
            updatedValue =
                Object.keys(updatedSrc).length === 0
                    ? null
                    : JSON.stringify(updatedSrc);
        }
        onChange(updatedValue);
    }
    function onEdit(edit) {
        change(edit.updated_src);
        if (reactJsonOptions === null || reactJsonOptions === void 0 ? void 0 : reactJsonOptions.onEdit) {
            reactJsonOptions.onEdit(edit);
        }
    }
    function onAdd(add) {
        change(add.updated_src);
        if (reactJsonOptions === null || reactJsonOptions === void 0 ? void 0 : reactJsonOptions.onAdd) {
            reactJsonOptions.onAdd(add);
        }
    }
    function onDelete(del) {
        change(del.updated_src);
        if (reactJsonOptions === null || reactJsonOptions === void 0 ? void 0 : reactJsonOptions.onDelete) {
            reactJsonOptions.onDelete(del);
        }
    }
    var src = value;
    if (jsonString) {
        src = value ? JSON.parse(value) : value;
    }
    return (React.createElement("div", null,
        React.createElement(Labeled, { source: source, label: label, isRequired: isRequired },
            React.createElement(ReactJson, __assign({}, reactJsonOptions, { src: src || {}, onEdit: (reactJsonOptions === null || reactJsonOptions === void 0 ? void 0 : reactJsonOptions.onEdit) === false ? false : onEdit, onAdd: (reactJsonOptions === null || reactJsonOptions === void 0 ? void 0 : reactJsonOptions.onAdd) === false ? false : onAdd, onDelete: (reactJsonOptions === null || reactJsonOptions === void 0 ? void 0 : reactJsonOptions.onDelete) === false ? false : onDelete }))),
        React.createElement(FormHelperText, { error: (isTouched || isSubmitted) && !!error },
            React.createElement(InputHelperText, { touched: isTouched || isSubmitted, error: error === null || error === void 0 ? void 0 : error.message, helperText: helperText }))));
};

export { JsonField, JsonInput };
//# sourceMappingURL=index.es.js.map
